import * as React from 'react';
import axios from 'axios';
import { useState } from 'react';
import { AddToCart } from './multiselect/AddToCart';
import { multiMint } from '../multiMint';

export function MoreInfo(props) {
  const [metadata, setMetadata] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const metaURL = `https://arweave.net/YQZohLE2nTVh8fZVjC54G3z_xgtGm5v9MqJLBYg8HCM/${props.id}.json`;
  const fetchMetadata = async () => {
    const response = await axios.get(metaURL);
    setMetadata(response.data);
  };

  return (
    <>
      <button
        type='button'
        onClick={() => {
          setShowCard(true);
          fetchMetadata();
        }}
      >
        <div
          className='inline-flex items-center justify-center px-2 py-1 text-sm font-medium leading-none text-primary border border-primary rounded-md'
          style={{ fontSize: '12px' }}
        >
          MORE INFO
        </div>
      </button>
      {showCard && (
        <div
          className='fixed inset-0 bg-black bg-opacity-80 z-50 flex h-full'
          onClick={() => {
            setShowCard(false);
          }}
        >
          <div
            className='fixed inset-0 bg-white z-51 flex flex-col h-full w-full md:w-2/3 left-auto ml-auto p-4 text-black'
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className='overflow-y-auto max-h-screen'>
              <div className='flex flex-col md:flex-row justify-between items-start'>
                <div className='mx-auto mb-4 md:mb-0 md:mr-4 relative'>
                  <img
                    src={props.image}
                    alt={metadata?.name}
                    className='object-contain md:max-h-96 md:max-w-96 max-h-64 max-w-64'
                  />
                </div>
                <div className='mx-auto'>
                  <h1 className='text-4xl font-bold'>{metadata?.name}</h1>
                  <h2>
                    <span className='font-bold'>Unique / One of a kind</span>
                  </h2>
                  <p style={{ paddingBottom: '10px' }}>
                    Current price: <br></br>
                    <span className='text-xl'>{props.price} ETH</span>
                  </p>
                  <AddToCart
                    id={props.id}
                    cart={props.cart}
                    ethPrice={props.ethPrice}
                    bigPrice={props.bigPrice}
                    inCart={props.inCart}
                    handleClick={props.handleClick}
                    setInCart={props.setInCart}
                    isSold={props.isSold}
                    style={{ paddingTop: '5px', paddingBottom: '5px' }}
                  />

                  <p style={{ paddingTop: '10px' }}>
                    <a
                      href='https://cerjlalonde.com/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Created by: Cerj Lalonde
                    </a>
                    <br></br>
                  </p>
                  <p>
                    <a
                      href='https://facingthesky.io/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Project: Facing The Sky
                    </a>
                  </p>
                  {/* <p>
                    <a
                      href={
                        'https://pro.opensea.io/profile/0x71664391476f32cd98cfd07230b4f00a0a2dc19c'
                      }
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Collection: SKYFACEs 1.0 to 100.0
                    </a>
                  </p> */}
                  <p>
                    <a
                      href={
                        'https://etherscan.io/address/0x71664391476F32CD98cfd07230B4F00A0a2Dc19C'
                      }
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Contract address: {multiMint.addr}
                    </a>
                  </p>
                  <p>Blockchain: Ethereum / ERC-721</p>
                  <p>Token ID: {metadata?.name}</p>
                  <p>
                    <a
                      href={multiMint.scan}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      View on Etherscan
                    </a>
                  </p>
                  <p>
                    <a href={metaURL} target='_blank' rel='noopener noreferrer'>
                      View Metadata
                    </a>
                  </p>
                </div>
              </div>
              <div className='mt-4 w-full'>
                <div className='flex flex-wrap justify-between items-center'>
                  <div className='text-left'>
                    <p>FUNDAMENTALLY, ART IS AT THE CORE OF THIS PROJECT. </p>
                    <p>
                      FACING THE SKY and the iconic SKYFACE digital collectibles
                      were created by post-contemporary nomad artist Cerj
                      Lalonde, who lived in the USA, China, and Canada.{' '}
                    </p>
                    <br></br>
                    <p>
                      Each SKYFACE symbolically represents at once a unique and
                      universal image of humanity, a techno-stylized
                      representation of us as human being - all races, all
                      genders, all ages inclusive.{' '}
                    </p>
                    <br></br>
                    <p>
                      One of the most exciting goals of the FACING THE SKY
                      project is our optimum vision of creating a Super
                      Intelligent Ultra-SKYFACE to help humanity grow through
                      the massive challenges that currently appear
                      insurmountable.
                    </p>
                    <p>
                      Join us and become a DIPLOMAT on this new exploration of
                      the future!{' '}
                    </p>
                    <p>
                      <span className=''>
                        <a
                          href='https://facingthesky.io/'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          FacingTheSky.io
                        </a>
                      </span>
                    </p>
                    <br></br>
                    <p>
                      Categories: #Art, #AGI, # Artificial General Intelligence,
                      #Geopolitics, #Culture, #Digital Collectible, #NFT,
                      #Metaverse
                    </p>
                    <br></br>
                    <br></br>
                    <p>FACING THE SKY</p>
                    <p>Montréal, Miami, Shanghai.</p>
                    <p className='font-bold'>
                      {' '}
                      <a
                        href='https://twitter.com/share?text=Check%20out%20this%20NFT%20collection!&url=https%3A%2F%2Fskyfacemint.web.app'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Share
                      </a>
                    </p>
                  </div>
                </div>
                © Cerj Lalonde
              </div>
            </div>
            <button
              className='absolute top-4 right-4 text-2xl font-bold'
              onClick={() => {
                setShowCard(false);
              }}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
}
